module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA8AAAAPCAYAAAA71pVKAAABT0lEQVQokYXTP2sVURAF8N9bQQS7ICoKKZIqCPoUBQs/xBZWWgWihUVMo/Xp09sKChZ+DsvwxKcR/AuxiAmKgRRBLMRiZ2VNIhm4DDNnzgz33LmSQIuX2MU7LCXRHyxVfhev0FZei9cYY4R5vMByFSxXPFf4uOrbUXW6lWRdWZIzmBThM64k2R7gF/CsweyQWOA2dnAJO0Ni4euYbfAtybyD9hvHy/9jVf+9wSqeJDl/SIMDVld6jNVezRVs4S3W6uzhRvk+N8VXrCQx6iVPcgKXcXIwaA1XB/EeJkl+9iS4j03dExw1efPvZNzBXdxMsjG42xT38CjJxUH+LJ7jaYMHuD0kHiHYFhbxsMHpJO8PqTuGX+X3N/iEUw02klzbB57DjG77Zioe4mN8odvtj7he4i3oVnO42xMsVDzGG7S92q1OyR/+/6s+FD5Vv+oPSp6UOY1mPHQAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/images/icons/sub_icon_menu_black.png
// module id = I7Ep
// module chunks = 2 3